import createElement from "../services/createElement";

const createSlide = (letter) => {
	const slide = createElement("div", "brendy__slider_slide");
	const overlay = createElement("div", "brendy__slider_slide-overlay");
	const overlayBlack = createElement(
		"div",
		"brendy__slider_slide-overlayBlack"
	);
	const overlayBorder = createElement("div", "brendy__slider_slide-border");
	const overlayBorderBox = createElement(
		"div",
		"brendy__slider_slide-border-box"
	);
	const letterDiv = createElement("div", "brendy__slider_slide-letter");
	letterDiv.textContent = letter;
	const letterSmallDiv = createElement(
		"div",
		"brendy__slider_slide-letterSmall"
	);
	letterSmallDiv.textContent = letter;
	const img = createElement("img", "brendy__slider_slide-bckg");
	img.src = `img/brendy/slider/${letter}.webp`;
	img.alt = "bckg";

	overlayBorder.appendChild(overlayBorderBox);
	slide.appendChild(letterDiv);
	slide.appendChild(overlayBlack);
	slide.appendChild(overlay);
	slide.appendChild(overlayBorder);
	slide.appendChild(letterSmallDiv);
	slide.appendChild(img);

	return slide;
};

const createSliderWithRange = (letters, startIndex, endIndex) => {
	const slide = createElement("div", "brendy__slider_wrapper");
	for (let i = startIndex; i < endIndex; i++) {
		const letter = letters[i];
		const slideItem = createSlide(letter);
		slide.appendChild(slideItem);
	}
	return slide;
};

export default createSliderWithRange;
